module.exports = __webpack_public_path__ + "static/media/user-profile.27aead14.svg";